/*
 * The fill page's scale at table size: a sunken track with five cells, the
 * picked one filled in its own colour. The unpicked cells keep their glyphs at
 * a whisper, so the eye still reads position on the scale, not just a hue.
 */
.mark {
  display: inline-flex;

  padding: 2px;

  background-color: var(--field);

  border-radius: var(--radius-s);

  cursor: help;
}

.step {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  min-width: 1.5rem;
  height: 1.25rem;

  font-size: var(--size-100);
  font-weight: var(--weight-strong);
  line-height: 1;
  font-variant-numeric: tabular-nums;

  color: rgb(255 255 255 / 0.28);

  border-radius: var(--radius-xs);

  transition: color var(--duration-fast) var(--ease);
}

.picked {
  color: #fff;
  background-color: var(--tone);
  box-shadow: 0 1px 2px rgb(0 0 0 / 35%);
}

.muchLess {
  --tone: var(--relevancy-much-less);
}

.less {
  --tone: var(--relevancy-less);
}

.equal {
  --tone: var(--relevancy-equal);
}

.more {
  --tone: var(--relevancy-more);
}

.muchMore {
  --tone: var(--relevancy-much-more);
}

/* Hovering the mark lets the neighbours come forward a touch, so the scale reads as a scale. */
.mark:hover .step:not(.picked) {
  color: rgb(255 255 255 / 0.5);
}
